import {
  CasMRTable,
  CasMRTCellRenderCurrrency,
  CasMRTCellRenderNumberWithCommas,
  CasMRTCellRenderDate,
} from 'src/compass/shared/components';
import { CommissionsTabProps } from '../PreliminaryCommissions';
import PreliminaryCommissionsTopToolbar from '../PreliminaryCommissionsTopToolbar';

export default function PreliminaryPayoutsLRPTab({
  data,
  exportUrl,
  ...rest
}: CommissionsTabProps) {
  const columns = [
    {
      accessorKey: 'employee',
    },
    {
      accessorKey: 'effectiveDate',
      Cell: CasMRTCellRenderDate,
    },
    {
      accessorKey: 'reinsuranceYear',
    },
    {
      accessorKey: 'policy',
    },
    {
      accessorKey: 'sce',
      header: 'SCE#',
    },
    {
      accessorKey: 'insuredName',
      header: 'Insured',
    },
    {
      accessorKey: 'endDate',
      Cell: CasMRTCellRenderDate,
    },
    {
      accessorKey: 'headCount',
      header: 'HC',
      Cell: CasMRTCellRenderNumberWithCommas,
    },
    {
      accessorKey: 'basePremium',
      header: 'Premium',
      Cell: CasMRTCellRenderCurrrency,
    },
    {
      accessorKey: 'description',
    },
    {
      accessorKey: 'schedule',
    },
    {
      accessorKey: 'rate',
    },
    {
      accessorKey: 'adjusted',
    },
    {
      accessorKey: 'commission',
      Cell: CasMRTCellRenderCurrrency,
    },
    {
      accessorKey: 'crop',
    },
  ];

  return (
    <CasMRTable
      data={data?.result}
      columns={columns}
      renderTopToolbarCustomActions={() => (
        <PreliminaryCommissionsTopToolbar total={data?.total} exportUrl={exportUrl} />
      )}
      enableGrouping={false}
      enablePagination={false}
      {...rest}
    />
  );
}
